import React from 'react'
import RichTextEditor from './RichTextEditor'
import { htmlToTextCount } from 'libs/text'
import { withFormsy } from 'formsy-react'
import _ from '@lodash'
import * as R from 'ramda'

export const richTextLengthValiator = R.curry((maxLength, values, value) => {
  return htmlToTextCount(value) <= maxLength && htmlToTextCount(value) > 0
})

function RichTextEditorFormsy(props) {
  const importedProps = _.pick(props, [
    'classes',
    'id',
    'label',
    'name',
    'maxLength',
    'value',
    'textStatus',
    'controls',
    'required',
    'isControlsInline',
    'isDoNotTranslateEnable',
    'isNoRichFormat',
    'linkEnabled',
    'tabIndex',
    'extraMsg',
    'readOnly',
    'onUploading',
    'onUploaded',
    'scrollableContainer',
    'onChangeImage',
  ])

  const changeValue = React.useCallback(
    function (value) {
      props.setValue(value)
      if (props.onChange) {
        props.onChange(value)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.setValue],
  )

  return (
    <RichTextEditor
      customControls={props.customControls}
      composeMessage={props.composeMessage}
      {...importedProps}
      initialValue={importedProps.value}
      value={props.value}
      onChange={changeValue}
    />
  )
}

export default React.memo(withFormsy(RichTextEditorFormsy))
